import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface ToolCallSummaryContentProps {
  children: ReactNode
  className?: string
  indicator?: ReactNode
}

export function ToolCallSummaryContent({ children, className, indicator }: ToolCallSummaryContentProps) {
  return (
    <span className={twMerge('pointer-events-none flex min-w-0 items-center gap-1.5', className)}>
      {indicator ?? (
        <svg width="14" height="14" viewBox="0 0 14 14" className="shrink-0" aria-hidden="true">
          <circle cx="7" cy="7" r="3" fill="#5B8CFF" />
        </svg>
      )}
      <span className="text-foreground-secondary line-clamp-1 text-[12px] leading-4">{children}</span>
    </span>
  )
}
